var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('SubNav'),_c('div',{staticClass:"overlap"},[_c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tab-links mob_hide"}),_c('div',{staticClass:"tab-content"},[_c('router-view')],1)])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }